<template>
  <div class="images">

    <div class="loader" v-if="images === 'loading'"></div><!-- /.loader -->

    <div class="error-msg" v-else-if="images === false">
      <h2 style="margin-top: 100px">
        It seems there are no images to display.
      </h2>
      <p>
        Please check your internet connection.
      </p>
    </div>
    <div class="image" v-for="image in images" v-else>
      <a v-bind:href="getImage(image.acf.image.url)" class="image__wrap" v-bind:title="image.title.rendered" target="_blank">
        <img v-lazy="getResponsiveImage(image.acf.image.sizes)" v-bind:alt="image.title.rendered">
      </a>
      <a v-bind:href="getImage(image.acf.image.url)" class="image__download"><span class="icon-download" target="_blank"></span> Download</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'images',
  data () {
    return {
      thefrontend: {
        url: 'https://thefrontend.uk'
      },
      images: 'loading'
    }
  },
  methods: {
    getImage: function (path) {
      return this.thefrontend.url + path
    },
    getResponsiveImage: function (path) {
      if (window.innerWidth > 768) {
        return this.thefrontend.url + path.lg
      } else if (window.innerWidth > 480 && window.innerWidth <= 768) {
        return this.thefrontend.url + path.sm
      } else {
        return this.thefrontend.url + path.xs
      }
    }
  },
  created: function () {
    this.$http.get('https://thefrontend.uk/wp-json/wp/v2/northerntake/?per_page=100')
      .then((response) => {
        this.images = response.data
      })
      .catch(() => {
        this.images = false
      })
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

// ============================
// Imports
// ============================

@import '../sass/variables.scss';
// @import '../sass/reset/nav';
// @import '../sass/reset/button';


.images {
  padding: 0 3.5em 0 7em;
  width:100%;
  //padding-right: 10em;
  margin-top:8em;
  text-align: center;

  @media screen and (max-width:756px) {
    padding: 0 1.5em 0 4em;
    margin-top:6em;
  }

  @keyframes rotate {
    0% {
      border-color: white;
      transform: scale(0);
    }
    50% {
      border-color: $brand-primary;
    }
    90% {
      border-color: white;
      transform: scale(1);
    }
    100% {
      border-color: white;
      transform: scale(0.5);
    }
  }

  .error-msg {
    align-self: center;
  }

  .loader {
    position: fixed;
    left:0;
    top:0;
    bottom:0;
    right:0;
    margin:auto;
    width: 2em; /* 32/16 */
    height: 2em;
    border: 4px solid;
    border-color: white;
    display:inline-block;
    animation-name: rotate;
    animation-iteration-count: infinite;
    animation-duration: 1s;
    border-radius: 50%;
  }

  .image {
    margin-bottom:10em;
    width:100%;
    max-width: 62.5em; /* 1000/16 */
    text-align: left;
    display: inline-block;

    @media screen and (max-width:756px) {
      margin-bottom: 3em;
    }

    a.image__wrap {
      display:inline-block;
      text-align: left;
      position: relative;
      width:100%;
      padding-top:66.7%;
      background-color: darken(white, 5%);
      margin-bottom:0.6em;

      @media screen and (min-width:1500px) {
        //width:75em;
      }

      img {
        width:100%;
        height:auto;
        position: absolute;
        z-index:999;
        transition: 0.5s;
        transform: translateY(200px);
        opacity: 0;
        top:0;

        &[lazy=loading] {
          opacity: 0;
        }
        &[lazy=error] {
          opacity: 0;
        }
        &[lazy=loaded] {
          opacity: 1;
          transform: translateY(0px);
        }
      }
    }

    .image__download {
      font-size: 1rem;
      text-decoration: none;
      color: $brand-primary;
      font-size: 0.8rem;
    }

  }
}

</style>



// WEBPACK FOOTER //
// Images.vue?693496b0